import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

/** Plain not-found: unknown routes, the wrong surface, foreign ids (spec §2.3, §4). */
export function NotFound({ inline, detail }: { inline?: boolean; detail?: string }) {
  return (
    <Center py={inline ? "xl" : 120} data-testid="not-found">
      <Stack align="center" gap="xs">
        <Title order={2}>Not found</Title>
        <Text c="dimmed">This page does not exist or you do not have access to it.</Text>
        {detail && (
          <Text size="sm" c="dimmed" data-testid="not-found-detail">
            {detail}
          </Text>
        )}
        {!inline && (
          <Button component={Link} to="/" variant="light" mt="sm">
            Go home
          </Button>
        )}
      </Stack>
    </Center>
  );
}
